import { FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import {
  ClientRiskToleranceSummary,
} from './ClientRiskToleranceSummary';


export const ClientRiskToleranceSummaryList = ({ collection }) => {
  return (
    <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2}>
      {collection.resources().list().map((r) => (
        <ClientRiskToleranceSummary key={r.id()} resource={r} />
      ))}
    </FDStack>
  );
};

ClientRiskToleranceSummaryList.propTypes = {
  collection: PropTypes.object.isRequired, // a collection of DetailListItem
};
